// NPM
import { graphql } from "gatsby"
import _ from "lodash"
import * as React from "react"

// Components
import GenericProduct from "src/components/pages/GenericProduct/GenericProduct"
import Layout from "src/layouts/fr"

const GenericProductPageFr = ({ location, data }) => {
  const topNav = data.topNav
  const sections = _.get(data, `genericProductPage.sections`, [])
  const newsItems = _.get(data, `newsItems.nodes`, [])
  const methodologies = _.get(data, `methodologies.nodes`, [])
  const methodology = methodologies.find(
    m => m.product && m.product.id === data.genericProductPage.id,
  )
  const bottomNav = data.bottomNav
  const socialMedia = _.get(data, `socialMedia.nodes`, [])

  return (
    <Layout
      location={location}
      topNav={topNav}
      page={data.genericProductPage}
      bottomNav={bottomNav}
      socialMedia={socialMedia}
    >
      <GenericProduct
        sections={sections}
        newsItems={newsItems}
        methodology={methodology}
        language="fr"
      />
    </Layout>
  )
}

export default GenericProductPageFr

export const query = graphql`
  query GenericProductPageFrQuery($id: String) {
    topNav: strapiTopNav(locale: { eq: "fr" }) {
      ...topNavContent
    }

    genericProductPage: strapiPage(id: { eq: $id }) {
      ...pageInformation
    }

    bottomNav: strapiBottomNav(locale: { eq: "fr" }) {
      ...bottomNavContent
    }

    newsItems: allStrapiNewsItem {
      nodes {
        ...newsItem
      }
    }

    methodologies: allStrapiMethodology(filter: { locale: { eq: "fr" } }) {
      nodes {
        ...methodology
      }
    }

    socialMedia: allStrapiSocialMedia(filter: { locale: { eq: "fr" } }) {
      nodes {
        ...socialMedia
      }
    }
  }
`
